import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import ProductTypeDetailsForm from "../../../components/forms/setup/productTypes/ProductTypeDetailsForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ProductTypesViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [productTypes, setProductTypes] = useState({ data: [] });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getProductTypes = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`productTypes`, payload);
    setLoading(false);
    if (callResult.success) {
      setProductTypes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createProductType = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createProductType", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product type added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getProductTypes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateProductType = async function (productType, values, index) {
    let callResult = await makePutApiCall(
      `productTypes/${productType.id}`,
      values,
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product type updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getProductTypes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddProductTypeSlideOver = () => {
    setSlideOver({
      childComponent: (
        <ProductTypeDetailsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createProductType}
        />
      ),
      open: true,
    });
  };

  const viewProductTypeDetails = async function (productType, index) {
    setSlideOver({
      childComponent: (
        <ProductTypeDetailsForm
          productType={productType}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateProductType}
        />
      ),
      open: true,
    });
  };

  const deleteProductType = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteProductType/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getProductTypes(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteProductType = function (productType, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteProductType(productType.id, index)}
          message={`Are you sure you want to delete ${productType.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteProductType,
    emptyModal,
    setEmptyModelOpen,
    createProductType,
    getProductTypes,
    loading,
    productTypes,
    openAddProductTypeSlideOver,
    setSlideOver,
    slideOver,
    updateProductType,
    viewProductTypeDetails,
  };
}
